/**
 * Shared utilities for harness sizing calculators.
 */

export const CM_PER_INCH = 2.54;

export const cmToInches = cm => cm / CM_PER_INCH;

/**
 * Parse a user input string to a finite number, or return NaN.
 */
export const sanitizeNumber = value => {
  const n = Number(String(value).trim());
  return Number.isFinite(n) ? n : NaN;
};

/**
 * Look up a value in a range table of [min, max, result] tuples.
 * Returns the result for the first matching range, or null.
 */
export const rangeLookup = (value, table) => {
  for (const [min, max, result] of table) {
    if (value >= min && value <= max) return result;
  }
  return null;
};
